import {
  type AssignableDomain,
  type AssignedDomainsResponse,
} from '../../types/permissions.types'

export const mockAssignedDomainsResponse: AssignedDomainsResponse = [
  {
    id: 'donations',
    area: 'Finance',
    name: 'Donations',
    description: 'Manage donation settings and configurations',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view donation data and reports',
        assigned: 'set',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage donation settings and configurations',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to donation management and settings',
      },
    ],
  },
  {
    id: 'grants',
    area: 'Grants',
    name: 'Grants',
    description: 'Manage grant programs and applications',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view grant programs and applications',
        assigned: 'inferred',
      },
      {
        id: 'reviewer',
        name: 'Reviewer',
        description: 'Can review and score grant applications',
        assigned: 'set',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage grant programs and settings',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to grant management and administration',
      },
    ],
  },
  {
    id: 'volunteering',
    area: 'Giving',
    name: 'Volunteering',
    description: 'Manage volunteering opportunities and programs',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view volunteering opportunities and data',
      },
      {
        id: 'coordinator',
        name: 'Coordinator',
        description: 'Can coordinate volunteering events and activities',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage volunteering programs and settings',
      },
    ],
  },
  {
    id: 'tenant',
    area: 'Internal',
    name: 'Internal Application',
    description: 'Manager of the internal application',
    canSetRoles: true,
    roles: [
      {
        id: 'admin',
        name: 'Super Admin',
        description:
          'Full access to internal application management and settings',
      },
    ],
  },
]

export const mockAssignedDomainsSuperAdminResponse: AssignedDomainsResponse = [
  {
    id: 'donations',
    area: 'Finance',
    name: 'Donations',
    description: 'Manage donation settings and configurations',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view donation data and reports',
        assigned: 'set',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage donation settings and configurations',
        assigned: 'inferred',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to donation management and settings',
        assigned: 'inferred',
      },
    ],
  },
  {
    id: 'grants',
    area: 'Grants',
    name: 'Grants',
    description: 'Manage grant programs and applications',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view grant programs and applications',
        assigned: 'inferred',
      },
      {
        id: 'reviewer',
        name: 'Reviewer',
        description: 'Can review and score grant applications',
        assigned: 'set',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage grant programs and settings',
        assigned: 'inferred',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to grant management and administration',
        assigned: 'inferred',
      },
    ],
  },
  {
    id: 'volunteering',
    area: 'Giving',
    name: 'Volunteering',
    description: 'Manage volunteering opportunities and programs',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view volunteering opportunities and data',
        assigned: 'inferred',
      },
      {
        id: 'coordinator',
        name: 'Coordinator',
        description: 'Can coordinate volunteering events and activities',
        assigned: 'inferred',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage volunteering programs and settings',
        assigned: 'inferred',
      },
    ],
  },
  {
    id: 'tenant',
    area: 'Internal',
    name: 'Internal Application',
    description: 'Manager of the internal application',
    canSetRoles: true,
    roles: [
      {
        id: 'admin',
        name: 'Super Admin',
        description:
          'Full access to internal application management and settings',
        assigned: 'set',
      },
    ],
  },
]

export const mockAssignedDomainsEmptyResponse: AssignedDomainsResponse = []

export const mockAssignedDomainsMultipleResponse: AssignedDomainsResponse = [
  {
    id: 'donations',
    area: 'Finance',
    name: 'Donations',
    description: 'Manage donation settings and configurations',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view donation data and reports',
        assigned: 'set',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage donation settings and configurations',
        assigned: 'set',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to donation management and settings',
      },
    ],
  },
  {
    id: 'grants',
    area: 'Grants',
    name: 'Grants',
    description: 'Manage grant programs and applications',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view grant programs and applications',
        assigned: 'set',
      },
      {
        id: 'reviewer',
        name: 'Reviewer',
        description: 'Can review and score grant applications',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage grant programs and settings',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to grant management and administration',
      },
    ],
  },
  {
    id: 'volunteering',
    area: 'Giving',
    name: 'Volunteering',
    description: 'Manage volunteering opportunities and programs',
    canSetRoles: true,
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view volunteering opportunities and data',
        assigned: 'set',
      },
      {
        id: 'coordinator',
        name: 'Coordinator',
        description: 'Can coordinate volunteering events and activities',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage volunteering programs and settings',
      },
    ],
  },
]

export const setDomainRole = (
  domain: AssignableDomain,
  role: string,
  assigned: 'set' | 'inferred' | undefined
) => ({
  ...domain,
  roles: domain.roles.map((r) => (r.id === role ? { ...r, assigned } : r)),
})
